import {
  GiveawayLuluandgeorgiaSss,
  getStaticProps,
} from '@public/GiveawayLuluandgeorgiaSss'

export { getStaticProps }

export default GiveawayLuluandgeorgiaSss
